import {
  IChangeMsisdnOrchestrator,
  IChangeSimEsimOrchestrator,
} from "@nju/data-access-portal-orchestrator";
import { IEsimQRCode } from "@nju/data-access-portal-sim-card";

interface IGetChangeSimEsimButtonsConditionProps {
  subState: IEsimQRCode["subState"] | undefined;
  changeMsisdnOrchestrator: IChangeMsisdnOrchestrator | undefined;
  changeSimEsimOrchestrator: IChangeSimEsimOrchestrator | undefined;
}

export function getChangeSimEsimButtonsCondition({
  subState,
  changeMsisdnOrchestrator,
  changeSimEsimOrchestrator,
}: IGetChangeSimEsimButtonsConditionProps) {
  const isChangeMsisdn =
    changeMsisdnOrchestrator &&
    !(
      changeMsisdnOrchestrator.state === "START" ||
      changeMsisdnOrchestrator.state === "COMPLETED"
    );

  const isChangeSimEsim =
    changeSimEsimOrchestrator &&
    !(
      changeSimEsimOrchestrator.state === "ORDER_SUMMARY" ||
      changeSimEsimOrchestrator.state === "COMPLETED"
    );

  if (isChangeMsisdn || isChangeSimEsim) {
    return true;
  }

  if (
    changeSimEsimOrchestrator?.state === "COMPLETED" &&
    changeSimEsimOrchestrator?.deliveryMethodId === "ESIM" &&
    subState !== "Downloaded"
  ) {
    return false;
  }

  return false;
}
